import { ChangeEvent, FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { CRM_MAX_FIELD_LENGTH } from '../../../common/config';
import { TemplateFlexGridContainer } from '../../../components/Grid';
import { Heading } from '../../../components/Heading';
import { InputGroup } from '../../../components/InputGroup';
import { Textarea } from '../../../components/Textarea';
import { noOp } from '../../../lib/utils';
import { StepProps } from '../../../types';
import { useBriefingState } from '../BriefingState';

export const StepModificationIssue: FC<StepProps> = ({
  // mandatoryFields,
  onValidate = noOp,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [{ modifyBriefingIssue }, { setModifyBriefingIssue }] =
    useBriefingState();

  const [isModificationIssueValid, setIsModificationIssueValid] =
    useState(true);
  const [initialIssue] = useState(modifyBriefingIssue);
  const isStepValid = useMemo(
    () => isModificationIssueValid,
    [isModificationIssueValid],
  );
  useEffect(() => onValidate(isStepValid), [isStepValid, onValidate]);

  const onIssueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setModifyBriefingIssue(event.target.value));
  };

  return (
    <TemplateFlexGridContainer.BriefingStep>
      <Heading
        level="h1"
        margin={0}
        text={t('topics:modification-issue:heading:general')}
      />
      <TemplateFlexGridContainer.BriefingStepBody>
        <div className="w-full md:w-8/12">
          <TemplateFlexGridContainer.BriefingStepSection>
            <div className="w-full">
              <InputGroup label={t('topics:modification-issue:explainIssue')}>
                <div className="w-full">
                  <Textarea
                    {...(initialIssue ? { initialValue: initialIssue } : {})}
                    rows={5}
                    onChange={onIssueChange}
                    onValidate={setIsModificationIssueValid}
                    maxLength={CRM_MAX_FIELD_LENGTH}
                  />
                </div>
              </InputGroup>
            </div>
          </TemplateFlexGridContainer.BriefingStepSection>
        </div>
      </TemplateFlexGridContainer.BriefingStepBody>
    </TemplateFlexGridContainer.BriefingStep>
  );
};
